module.exports = __webpack_public_path__ + "img/limitation21.78a9d31a.svg";